<template>
    <div class="row">
        <div v-for="(option, ok) in options" :key="ok"
            class="col-6 col-md-4 my-2 my-lg-4 box">
            <img :src="'/assets/img/avatars/class/' + option + '.svg'"
                :class="{
                    'img-fluid': true,
                    'selected': option == internalValue,
                    'not-selected': option != internalValue
                }"
                @click="internalValue = option">
        </div>
    </div>
</template>
<script>

export default{
    props: {
        value: String
    },
    data(){
        return {
            options: [
                '1', '2', '3',
                '4', '5', '6'
            ],
            internalValue: String
        }
    },
    watch:{
        internalValue(){
            window.$('#avatar').val(this.internalValue)
            window.$('#avatar-img').attr('src', '/assets/img/avatars/class/' + this.internalValue + '.svg')
        }
    },
    mounted(){
        this.internalValue = this.value
    }
}

</script>
<style scoped>
.box img{
    padding: 3px;
    margin: 3px;
}

.selected{
    border: 2px solid lightgreen;
    border-radius: 3px;
}
.not-selected{
    border: 2px solid white;
    border-radius: 3px;
}
</style>